export default __webpack_public_path__ + "static/media/EmptyState.36cfba60.svg";